import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui

import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Pagination,
  Button,
  Box,
  Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ShowIcon } from '../../../theme/images/showTableIcon.svg';
import { ReactComponent as EditIcon } from '../../../theme/images/editTableIcon.svg';

// components
import Scrollbar from '../../../components/scrollbar';
// sections
import ClientHeadTable from '../../../components/clientHeadTable/ClientHeadTable';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function UsersListTable({ usersList, handleChangePage, page, setShow }) {
  const navigate = useNavigate();
  const [rowsPerPage] = useState(10); // Set a default value for rowsPerPage

  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';
  const TABLE_HEAD = [
    { id: 'name', label: t('users.userName'), alignRight: isRtl && true },
    { id: 'email', label: t('users.userEmail'), alignRight: isRtl && true },
    { id: 'phoneNumber', label: t('users.phoneNumber'), alignRight: isRtl && true },
    { id: 'dateOfBirth', label: t('users.dateOfBirth'), alignRight: isRtl && true },
    { id: 'verfied', label: t('users.verfied'), alignRight: isRtl && true },
    { id: 'registerFrom', label: t('users.registerFrom') || 'مصدر التسجيل', alignRight: isRtl && true },

    { id: 'actions', label: t('General.Action'), alignRight: isRtl && true },
  ];
  return (
    <>
      <Scrollbar>
        <TableContainer sx={{ minWidth: 800 }}>
          <Table>
            <ClientHeadTable headLabel={TABLE_HEAD} />
            <TableBody>
              {usersList?.content?.map((row) => {
                const { userId, fullName, email, phone, birthDate, isVerified, registerFrom } = row;
                const registerFromText =
                  registerFrom === 'SaudiProjects'
                    ? t('users.saudiProjects') || 'مشاريع السعودية'
                    : t('users.maskeen') || 'مساكن';
                return (
                  <TableRow hover key={userId} tabIndex={-1}>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left', maxWidth: 180 }} component="th" scope="row">
                      <Tooltip title={fullName || ''} placement="top" arrow enterDelay={400}>
                        <Typography variant="subtitle2" noWrap>
                          {fullName}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left', maxWidth: 200 }} align="left">
                      <Tooltip title={email || ''} placement="top" arrow enterDelay={400}>
                        <Typography variant="body2" noWrap>
                          {email}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left', maxWidth: 140 }} align="left">
                      <Tooltip title={phone || ''} placement="top" arrow enterDelay={400}>
                        <Typography variant="body2" noWrap>
                          {phone}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left', maxWidth: 130 }} align="left">
                      <Tooltip title={birthDate || ''} placement="top" arrow enterDelay={400}>
                        <Typography variant="body2" noWrap>
                          {birthDate}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell component="th" scope="row" sx={{ textAlign: isRtl ? 'right' : 'left' }}>
                      {isVerified === '1' ? (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#E7F7EF',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#0CAF60', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('users.verfied')}
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '4px 16px',
                            backgroundColor: '#FFEDEC',
                            borderRadius: '8px',
                            width: '88px',
                          }}
                        >
                          <Typography
                            sx={{ color: '#E03137', fontWeight: '700', fontSize: '10px', lineHeight: '16px' }}
                            variant="subtitle2"
                            textAlign={'center'}
                            noWrap
                          >
                            {t('users.unverfied')}
                          </Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left', maxWidth: 150 }} align="left">
                      <Tooltip title={registerFromText || ''} placement="top" arrow enterDelay={400}>
                        <Typography variant="body2" noWrap>
                          {registerFromText}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell sx={{ textAlign: isRtl ? 'right' : 'left' }} align="left">
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '2px',
                        }}
                      >
                        <Button
                          onClick={() =>
                            navigate(`/dashboard/users/view/${userId}`, { state: { user: row } })
                          }
                        >
                          <ShowIcon />
                        </Button>{' '}
                        <Button
                          onClick={() =>
                            setShow((prev) => {
                              return { ...prev, open: true, userId, mode: 'edit' };
                            })
                          }
                        >
                          <EditIcon />
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Scrollbar>
      {usersList?.length === 0 && (
        <Box textAlign="center">
          <h5>No data found</h5>
        </Box>
      )}
      {usersList?.totalPages > 0 && (
        <Box
          sx={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            marginTop: '5rem',
          }}
        >
          <Pagination count={usersList.totalPages} page={page + 1} onChange={handleChangePage} color="primary" />
          <Box sx={{ display: 'block' }}>
            {t('General.showing')} {page * rowsPerPage + 1} {t('General.to')}{' '}
            {Math.min((page + 1) * rowsPerPage, usersList.totalElements)} {t('General.of')} {usersList.totalElements}{' '}
            {t('General.entries')}
          </Box>
        </Box>
      )}
    </>
  );
}
